<template>
  <nav>
    <ol class="tw-m-0 tw-flex tw-list-none tw-flex-wrap tw-p-0">
      <slot />
    </ol>
  </nav>
</template>
